// ⚠️ AUTO-GENERATED FILE - DO NOT MODIFY MANUALLY
    // This file was generated by the DTO generator script.
    // Any changes will be overwritten during the next build.

    import { IBSETBase } from '../Interfaces/IBSETBase';
export class SuperBase implements IBSETBase {
  declare referenceNumber: string;
  declare itemName: string;
  declare description: string;
  declare cost: number;
}
